var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 897,
    height: 811,
    viewBox: "0 0 897 811",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M896.744 405.523L563.278 352.399L694.453 182.933L507.053 301.555L448.308 0L389.562 301.555L202.163 182.933L333.337 352.399L0 405.523L333.44 458.647L202.266 628.23L389.639 509.608L448.385 811L507.131 509.468L694.684 628.23L563.355 458.601L896.744 405.523Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M443.24 435.435V688.494L403.168 471.696L443.24 435.435Z",
    fill: "#151B47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M415.231 400.941H135.393L375.133 364.68L415.231 400.941Z",
    fill: "#151B47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M453.35 375.611V122.599L493.422 339.374L453.35 375.611Z",
    fill: "#151B47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M481.385 410.105H761.198L521.483 446.32L481.385 410.105Z",
    fill: "#151B47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c28cbeb5e67edef519b3fdd29bc957cf.svg";
export { ForwardRef as ReactComponent };